import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import accountReducer from './account/account.reducer';
import addressReducer from './address/address.reducer';
import { LOGOUT } from './auth/auth.actions';
import authReducer from './auth/auth.reducer';
import claimReducer from './claim/claim.reducer';
import claimItemReducer from './claim-item/claim-item.reducer';
import claimListReducer from './claim-list/claim-list.reducer';
import claimStripePaymentsReducer from './claim-stripe-payments/claim-stripe-payments.reducer';
import claimResponseDeadlineExtensionsReducer from './claim-response-deadline-extensions/claim-response-deadline-extensions.reducer';
import commissionReducer from './commission/commission.reducer';
import documentReducer from './document/document.reducer';
import enititiesReducer from './entities/entities.reducer';
import errorReducer from './error/error.reducer';
import flashMessagesReducer from './flash-messages/flash-messages.reducer';
import guarantorReducer from './guarantor/guarantor.reducer';
import integratorReducer from './integrator/integrator.reducer';
import internalTeamMemberReducer from './internal-team-member/internal-team-member.reducer';
import inviteReducer from './invite/invite.reducer';
import kpiDocumentReducer from './kpi-document/kpi-document.reducer';
import landlordReducer from './landlord/landlord.reducer';
import loadingReducer from './loading/loading.reducer';
import manualPaymentsReducer from './manual-payments/manual-payments.reducer';
import modalReducer from './modal/modal.reducer';
import orderReducer from './order/order.reducer';
import organizationReducer from './organization/organization.reducer';
import organizationBankAccountReducer from './organization-bank-account/organization-bank-account.reducer';
import organizationBrandingReducer from './organization-branding/organization-branding.reducer';
import organizationGroupReducer from './organization-group/organization-group.reducer';
import organizationGroupManagementReducer from './organization-group/organization-group-management.reducer';
import organizationInternalOwnerReducer from './organization-internal-owner/organization-internal-owner.reducer';
import organizationListReducer from './organization-list/organization-list.reducer';
import recipientReducer from './organization-recipient/organization-recipient.reducer';
import organizationVerticalReducer from './organization-vertical/organization-vertical.reducer';
import propertiesReducer from './property/property.reducer';
import reconciliationDocumentReducer from './reconciliation-document/reconciliation-document.reducer';
import referencingListReducer from './reference-list/reference-list.reducer';
import referencingReducer from './referencing/referencing.reducer';
import repositReducer from './reposit/reposit.reducer';
import repositListReducer from './reposit-list/reposit-list.reducer';
import systemReducer from './system/system.reducer';
import tenancyAnniversaryReducer from './tenancy-anniversary/tenancy-anniversary.reducer';
import userReducer from './user/user.reducer';
import userListReducer from './user-list/user-list.reducer';

const appReducer = (history: History<any>) =>
  combineReducers({
    account: accountReducer,
    address: addressReducer,
    claim: claimReducer,
    claimItem: claimItemReducer,
    claimList: claimListReducer,
    auth: authReducer,
    entities: enititiesReducer,
    loading: loadingReducer,
    error: errorReducer,
    flashMessages: flashMessagesReducer,
    user: userReducer,
    invite: inviteReducer,
    properties: propertiesReducer,
    reposit: repositReducer,
    repositList: repositListReducer,
    system: systemReducer,
    router: connectRouter(history),
    referencing: referencingReducer,
    document: documentReducer,
    landlord: landlordReducer,
    userList: userListReducer,
    referencingList: referencingListReducer,
    organizationList: organizationListReducer,
    integrator: integratorReducer,
    kpiDocument: kpiDocumentReducer,
    tenancyAnniversaries: tenancyAnniversaryReducer,
    modal: modalReducer,
    commission: commissionReducer,
    recipients: recipientReducer,
    organizationBankAccounts: organizationBankAccountReducer,
    guarantor: guarantorReducer,
    order: orderReducer,
    reconciliationDocument: reconciliationDocumentReducer,
    internalTeamMember: internalTeamMemberReducer,
    organizationInternalOwner: organizationInternalOwnerReducer,
    organizationVertical: organizationVerticalReducer,
    organization: organizationReducer,
    organizationBranding: organizationBrandingReducer,
    organizationGroup: organizationGroupReducer,
    organizationGroupManagement: organizationGroupManagementReducer,
    manualPayments: manualPaymentsReducer,
    claimStripePayments: claimStripePaymentsReducer,
    claimResponseDeadlineExtensions: claimResponseDeadlineExtensionsReducer,
  });

export const rootReducer = (history: History, state: any, action: any) => {
  if (action.type === LOGOUT) {
    state = undefined;
  }
  return appReducer(history)(state, action);
};

export type AppState = ReturnType<typeof rootReducer>;

export const getRootReducer = (history: History) => (state: any, action: any) => rootReducer(history, state, action);
